import fire from '@store/firebase';
import { ICustomBot } from '@typings/customBot/customBot.interface';
import { CollectionPath } from '@typings/collections.enum';

const firestore = fire.firestore();
const customBotsRef = firestore.collection(CollectionPath.CUSTOM_BOTS);

// 🎯 새 봇 추가
export async function addCustomBot(data: Partial<ICustomBot>, authorUid: string) {
  const newBotData: Partial<ICustomBot> = {
    ...data,
    authorUid,
    createdAt: new Date(),
    editedAt: new Date(),
    usageCount: 0,
    isActive: data.isActive ?? true,
  };

  // undefined 제거
  const cleanedData = Object.fromEntries(
    Object.entries(newBotData).filter(([_, v]) => v !== undefined)
  );

  return customBotsRef
    .add(cleanedData)
    .then((res) => {
      console.log('✅ 커스텀 봇 추가 완료:', res.id);
      return res.id;
    })
    .catch((err) => {
      console.error('❌ 커스텀 봇 추가 실패:', err);
      throw err;
    });
}

// 🎯 봇 업데이트
export async function updateCustomBot(botId: string, data: Partial<ICustomBot>) {
  const updateData = {
    ...data,
    editedAt: new Date(),
  };

  // undefined 제거
  const cleanedData = Object.fromEntries(
    Object.entries(updateData).filter(([_, v]) => v !== undefined)
  );

  return customBotsRef
    .doc(botId)
    .update(cleanedData)
    .then(() => {
      console.log('✅ 커스텀 봇 업데이트 완료:', botId);
    })
    .catch((err) => {
      console.error('❌ 커스텀 봇 업데이트 실패:', err);
      throw err;
    });
}

// 🎯 봇 삭제
export async function deleteCustomBot(botId: string) {
  return customBotsRef
    .doc(botId)
    .delete()
    .then(() => {
      console.log('✅ 커스텀 봇 삭제 완료:', botId);
    })
    .catch((err) => {
      console.error('❌ 커스텀 봇 삭제 실패:', err);
      throw err;
    });
}

// 🎯 봇 활성화 토글
export async function toggleCustomBotActive(botId: string, currentStatus: boolean) {
  return customBotsRef
    .doc(botId)
    .update({
      isActive: !currentStatus,
      editedAt: new Date(),
    })
    .then(() => {
      console.log('✅ 커스텀 봇 활성화 토글 완료:', botId);
    })
    .catch((err) => {
      console.error('❌ 커스텀 봇 활성화 토글 실패:', err);
      throw err;
    });
}

// 🎯 봇 사용 횟수 증가
export async function incrementBotUsage(botId: string) {
  // TODO: 봇 사용 횟수 증가 로직 구현
  // return customBotsRef
  //   .doc(botId)
  //   .update({
  //     usageCount: fire.firestore.FieldValue.increment(1),
  //   })
  //   .catch((err) => {
  //     console.error('❌ 봇 사용 횟수 증가 실패:', err);
  //   });
}

// 🎯 모든 활성화된 봇 가져오기
export async function getActiveBots(): Promise<ICustomBot[]> {
  return customBotsRef
    .where('isActive', '==', true)
    .get()
    .then((snapshot) => {
      return snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      } as ICustomBot));
    })
    .catch((err) => {
      console.error('❌ 활성화된 봇 조회 실패:', err);
      return [];
    });
}

